import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PluginsService } from './../plugins/plugins.service';

@Injectable({
  providedIn: 'root'
})
export class PluginsResolve {

  constructor(
    private ps: PluginsService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.ps.updatePluginsPicker()
  }
}
